"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = hexToRgb;

/* eslint-disable no-param-reassign */
function hexToRgb(color) {
  if (color.charAt(0) !== '#') {
    return '';
  }

  color = color.substr(1);

  if (color.length !== 3 && color.length !== 6) {
    return '';
  }

  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}